import React from 'react';
import { Route, Routes } from 'react-router-dom';
import MainWrapper from '../MainWrapper';
import Landing from '../../Landing/index';
import NotFound404 from '../../DefaultPage/404/index';
import LockScreen from '../../Account/LockScreen/index';
import LogIn from '../../Account/LogIn/index';
// import LogInPhoto from '../../Account/LogInPhoto/index';
import Register from '../../Account/Register/index';
// import RegisterPhoto from '../../Account/RegisterPhoto/index';
import ResetPassword from '../../Account/ResetPassword/index';
// import ResetPasswordPhoto from '../../Account/ResetPasswordPhoto';
import WrappedRoutes from './WrappedRoutes';

const Router = () => (
  <MainWrapper>
    <main>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/404" element={<NotFound404 />} />
        <Route path="/lock_screen" element={<LockScreen />} />
        <Route path="/login" element={<LogIn />} />
        {/* <Route path="/log_in_photo" element={<LogInPhoto />} /> */}
        <Route path="/register" element={<Register />} />
        {/* <Route path="/register_photo" element={<RegisterPhoto />} /> */}
        <Route path="/reset_password" element={<ResetPassword />} />
        {/* <Route path="/reset_password_photo" element={<ResetPasswordPhoto />} /> */}
        <Route path="/*" element={<WrappedRoutes />} />
      </Routes>
    </main>
  </MainWrapper>
);

export default Router;